module.exports = __webpack_public_path__ + "fonts/GTAmericaMono-Medium.c631c86a.woff";